export const replaceItemAtIndex = <T>(
  list: T[],
  item: T,
  index: number,
): T[] => {
  if (index === list.length - 1) {
    return [...list.slice(0, index), item];
  }

  return [...list.slice(0, index), item, ...list.slice(index + 1, list.length)];
};

export const addItemAtIndex = <T>(list: T[], item: T, index: number): T[] => {
  const newList = [...list];
  newList.splice(index, 0, item);
  return newList;
};

export const removeItemAtIndex = <T>(list: T[], index: number): T[] => {
  if (index > list.length - 1) {
    return [...list.slice(index - 1)];
  }

  return [...list.slice(0, index), ...list.slice(index + 1, list.length)];
};
